import { useAuth0 } from '@auth0/auth0-react';
import React from 'react';
import { ConfigContext } from '../../providers/ConfigContext';
import { Button } from 'ui-components/src/components/atoms/Button';
import { Container, Subtitle, Title } from './styles';

export const NotAuthorizedView = () => {
  const { logout } = useAuth0();
  const config = ConfigContext.useContainer();

  return (
    <Container>
      <Title>You are not authorized to use this application</Title>
      <Subtitle>
        If this is incorrect then please contact your administrator to request
        access
      </Subtitle>
      <Button
        onClick={() =>
          logout({ logoutParams: { returnTo: config.auth0.logout_uri } })
        }
      >
        Log out
      </Button>
    </Container>
  );
};
